export const WIDGET_TYPE_FILE_UPLOAD = 'FileUploadField' as const;
export const UI_FIELD = 'ui:field' as const;
export const UI_ORDER = 'ui:order' as const;
export const UI_OPTIONS = 'ui:options' as const;
